export default __webpack_public_path__ + "static/O0260-adf03acb98e1f09f2c2db12b46ef91ed.png";